<div class="enrolment-form">
  <div class="enrolment-form__error" #errorMessage>
    @if (form()?.invalid && submitted()) {
    <lx-error-message></lx-error-message>
    }
  </div>

  <form [formGroup]="form()">
    <h3 class="enrolment-form__section-title enrolment-form__section-title--first" i18n>Your details</h3>
    <div class="enrolment-form__form-row">
      <lx-form-field-lite [control]="form().controls.firstName" i18n-label label="First Name">
        <input [attr.autocomplete]="'given-name'" data-qa="yourInfo_inputFirstName" formControlName="firstName" pInputText type="text" />
      </lx-form-field-lite>

      <lx-form-field-lite [control]="form().controls.lastName" i18n-label label="Last Name">
        <input [attr.autocomplete]="'family-name'" data-qa="yourInfo_inputLastName" formControlName="lastName" pInputText type="text" />
      </lx-form-field-lite>
    </div>

    <lx-form-field-lite [control]="form().controls.email" i18n-label label="Email">
      <input [attr.autocomplete]="'email'" data-qa="yourInfo_inputEmail" formControlName="email" pInputText type="email" />
    </lx-form-field-lite>

    <lx-form-field-lite [control]="form().controls.phoneNumber" i18n-label label="Phone">
      <lx-phone-number-field i18n-title title="Phone code" formControlName="phoneNumber" data-qa="enrolmentForm_phoneNumber"></lx-phone-number-field>
    </lx-form-field-lite>

    <!-- Before you continue Section -->
    <h3 class="enrolment-form__section-title enrolment-form__section-title--with-extra-margin" i18n>Before you continue</h3>

    <div class="enrolment-form__checkbox enrolment-form__checkbox--spaced">
      <p-checkbox [binary]="true" data-qa="yourInfo_termsAndConditionsConsent" formControlName="termsAndConditionsConsent"></p-checkbox>
      <div
        [class.enrolment-form__checkbox__label--error]="
          form().controls.termsAndConditionsConsent?.invalid && (form().controls.termsAndConditionsConsent?.touched || submitted())
        "
        class="enrolment-form__checkbox__label"
      >
        <span i18n> I completely agree with the terms and conditions of {{ company | lxCompanyFormattedName }}. </span>
        <span class="enrolment-form__checkbox__label__required">*</span>
        <a
          [class.enrolment-form__checkbox__label__link--error]="
            form().controls.termsAndConditionsConsent?.invalid && (form().controls.termsAndConditionsConsent?.touched || submitted())
          "
          [href]="termsAndConditionsLink"
          class="enrolment-form__checkbox__label__link"
          i18n
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions
        </a>
      </div>
    </div>

    <div class="enrolment-form__checkbox">
      <p-checkbox [binary]="true" data-qa="yourInfo_optOutMarketing" formControlName="optOutMarketing"></p-checkbox>
      <div class="enrolment-form__checkbox__label" i18n>
        We'd like to keep in touch to share the latest news and special offers from the Kaplan Languages Group. If this isn't for you, tick the box to opt out.
      </div>
    </div>

    <div class="enrolment-form__privacy-policy" i18n>
      {{ company | lxCompanyFormattedName }} is committed to respecting and preserving your privacy.
      <a [href]="privacyPolicyLink" target="_blank" rel="noopener noreferrer" class="enrolment-form__privacy-policy__link">More Info</a>
    </div>

    <lx-acquisition-disclaimer></lx-acquisition-disclaimer>
  </form>
</div>
